module.exports = __webpack_public_path__ + "img/pos-indo-logo.15415324.png";